import React, { useState } from "react";
import helpIcon from "../../../assets/images/helpIcon.svg";
import Tooltip from "./Tooltip";

interface CardProps {
  title: string;
  helpDetails: string[];
  value: string | number;
  percentage: number;
  conversionRate?: number;
}

export function Card({ title, helpDetails, value, percentage, conversionRate }: CardProps) {
  const isNegative = percentage < 0;
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="analytics-card">
      <div className="analytics-card__title">
        <span>{title}</span>

        <div className="analytics-card__help" onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}>
          <img src={helpIcon} alt="Help" />

          <div className={`analytics-card__tooltip ${showTooltip ? "show" : ""}`}>
            <Tooltip details={helpDetails} position="left" />
          </div>
        </div>
        {conversionRate! >= 0 && conversionRate !== null && title !== "Visited" ? (
          <div className="ml-auto analytics-card__conversion">Conversion: {conversionRate}%</div>
        ) : null}
      </div>

      <div className="analytics-card__divider mt-4" />

      <div className="analytics-card__bottom pt-3">
        <span className="analytics-card__value">{value}</span>
        {percentage !== null ? (
          <span className={`analytics-card__percentage ${isNegative ? "negative" : "positive"}`}>
            {percentage}%<span className="analytics-card__arrow">{isNegative ? "▼" : "▲"}</span>
          </span>
        ) : null}
      </div>
    </div>
  );
}
